import React from "react";
import './style.css';
import Logo from '../../assets/img/logo/Save-Logo-White.webp';

const Navbar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg fixed-top">
        <div className="container py-2">
          <a className="navbar-brand pe-2" href="/home">
            <img src={Logo}
              alt="Logo"
              className="d-inline-block align-text-top"
              style={{width: 'auto', height: 40}}/>
          </a>
          <button
            className="navbar-toggler light"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;